import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-peek-account',
  templateUrl: './peek-account.page.html',
  styleUrls: ['./peek-account.page.scss'],
})
export class PeekAccountPage implements OnInit {

  peekedProfile;
  cleanSupportURL;
  szer = '100%';
  wysoko = '1700px';

  
  
  constructor(private router: Router, public modalController: ModalController, public sanitizer: DomSanitizer, public auth: AuthService) {
    this.peekedProfile = this.auth.peekingProfile;
  }

  ngOnInit() {
    console.log(this.auth.peekingProfile);
    const link = 'assets/kompas/results.html?e=' 
        + this.peekedProfile.e + '&d=' + this.peekedProfile.d + '&g=' + this.peekedProfile.g + '&s=' + this.peekedProfile.s;

    console.log('link', link);
    this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }

  openAccount()
  {

    // console.log('this.peekedProfile', this.peekedProfile.uid);
    // this.router.navigate(['profile/', this.peekedProfile.uid ]);
    const domain = window.location.protocol + '//' + window.location.host + '/profile/' + this.peekedProfile.uid;
    // console.log('domain', domain);
    window.location.replace(domain);
    // (window).open(domain);
  }


  dismiss()
  {
    this.modalController.dismiss();
  }
}
